import { Directive, HostListener, Input } from '@angular/core';

@Directive({
	selector: '[decimalOnly]'
})
export class DecimalDirective {
	// tslint:disable-next-line:no-input-rename
	@Input('decimalOnly') decimalOnly: string;
	private readonly allowableKeys: string[] = ['Backspace', 'Tab', 'End', 'Home', 'ArrowLeft', 'ArrowRight'];
	private twoDigitAllowablePattern: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g); // Digits and decimals up to 2 places
	private singleDigitAllowablePattern: RegExp = new RegExp(/^\d*\.?\d?$/g); // Only one decimal digit place

	@HostListener('keydown', ['$event'])
	public onKeyDown(event: KeyboardEvent): void {
		if (this.allowableKeys.includes(event.key)) {
			return;
		}

		// A user may select all or part of an existing input's value to replace
		const selectionStart: number = (event.currentTarget as HTMLInputElement).selectionStart;
		const selectionEnd: number = (event.currentTarget as HTMLInputElement).selectionEnd;

		const currentValue: string = (event.currentTarget as HTMLInputElement).value;

		// This is replacing a selection with the pressed key
		const proposedValue: string = [
			currentValue.slice(0, selectionStart),
			event.key,
			currentValue.slice(selectionEnd)
		].join('');

		if (this.decimalOnly === 'twoDigitDecimalNumber' && !proposedValue.match(this.twoDigitAllowablePattern)) {
			event.preventDefault();
		}
		if (this.decimalOnly === 'singleDigitDecimalNumber' && !proposedValue.match(this.singleDigitAllowablePattern)) {
			event.preventDefault();
		}
	}
}
